module.exports = __webpack_public_path__ + "img/icon3.7be3f4a5.png";